import * as React from 'react';

interface Props {
  message: string;
}

export default function ErrorLabel(props: Props) {
  return <div className='ld-alert ld-error-alert title-error'>{props.message}</div>;
}
